export const changeSignalOptions = (options) => ({
  type: 'CHANGE_SIGNAL_OPTIONS',
  payload: options
});
